import WF1 from '../../../media/GW/Westfield.webp'
import WF2 from '../../../media/GW/Westfield (2).webp'



const WFimages =[
WF1,WF2,
]

export default WFimages;